const MAX_IMAGE_SIZE_MB = 25;
const MAX_VIDEO_SIZE_MB = 100;

export const isValidMedia = (
  file: File
): { valid: boolean; error?: string } => {
  const isImage = file.type.startsWith("image/");
  const isVideo = file.type.startsWith("video/");

  if (isImage && file.size > MAX_IMAGE_SIZE_MB * 1024 * 1024) {
    return {
      valid: false,
      error: `Image files must be under ${MAX_IMAGE_SIZE_MB}MB.`,
    };
  }

  if (isVideo && file.size > MAX_VIDEO_SIZE_MB * 1024 * 1024) {
    return {
      valid: false,
      error: `Video files must be under ${MAX_VIDEO_SIZE_MB}MB.`,
    };
  }

  if (!isImage && !isVideo) {
    return { valid: false, error: "Only image and video files are supported." };
  }

  return { valid: true };
};
